import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag, Form } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import { Modal, } from 'antd';
import { DatePicker, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { makeStyles } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Backdrop } from '@mui/material';

const Lessor: React.FC = (props: any) => {

 

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },backdrop: {
      background: "black",
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }));

  const [currentLessor, setCurrentLessor] = useState({});
  const [enteredstatus, setEnteredStatus] = useState("");



  const classes = useStyles();

  const columns = [

    { field: 'id', headerName: 'ID', width: 170 },
    { field: 'Name', headerName: 'NAME', width: 170 },
    { field: 'Email', headerName: 'EMAIL', width: 170 },
    { field: 'ContactNo', headerName: 'CONTACT NUMBER', width: 250 },
    { field: 'UserType', headerName: 'USER TYPE', width: 170 },
    // { field: 'VerifiedStatus', headerName: 'VERIFICATION', width: 170 },
    {
      field: 'details', headerName: 'DETAILS', width: 190,
      renderCell: (params: GridCellParams) => (<strong>
        <Button
          variant="contained"
          onClick={() => { showModal(params.value) }}
          color="primary"
          size="small"
          style={{ marginLeft: 5 }} > View Lessor Details </Button> </strong>),
    },
    {
      field: 'ProfileStatus', headerName: 'PROFILE STATUS', width: 190,
      renderCell: (params: GridCellParams) => (<strong>
      
          
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            style = {{width:"180px"}}
            onChange={(e) => statusChangeHandler(e, params.row)}
            value={params.value}
    
          >
            <MenuItem value={"Accepted"}>Accepted</MenuItem>
            <MenuItem value={"Rejected"}>Rejected</MenuItem>
          </Select>
        </strong>),
    }

  ];

  const [data1, SetData] = useState([]);
  const [open, setOpen] = useState(true);

  const handleBackDropClose = () => {
    setOpen(false);
  };

  useIonViewDidEnter(() => {

    axios.get('https://dev.northroom.co.za/api/bizprop/lessors/all')
      .then(function (response) {
        // handle success
        console.log(response.data);
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });


  });

  useEffect(() => {
    
  }, [currentLessor]);

  const statusChangeHandler = (event:any,Lessor: any) => {

    setEnteredStatus(event.target.value);
    setCurrentLessor(Lessor);
    showAcceptModal();
    
};

  async function UpdateLessor() {
    /* @ts-ignore */
    let tempLessor = currentLessor;
    /* @ts-ignore */
    tempLessor.ProfileStatus = enteredstatus;
    /* @ts-ignore */
    
    console.log(tempLessor);

    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/users/client/save",
        data: tempLessor,
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }
    
    
  }


  const {name } = useParams<{ name: string; }>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalAcceptedVisible, setIsAcceptedModalVisible] = useState(false);

  const showModal = (record: any) => {

    let MainRecord = JSON.parse(record);
    console.log(record);
    
    setState(prevstate=>({...prevstate,...MainRecord}));

    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showAcceptModal = () => {
    setIsAcceptedModalVisible(true);
  };

  const handleAcceptOk = () => {
    setIsAcceptedModalVisible(false);
    UpdateLessor();
  };
  
  const user = JSON.parse(localStorage.getItem("userobject") || '{}');
  
  const [PropertyObject, setState] = useState({
   

  });
 
  return (

    <IonPage>
       <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      ></Backdrop>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              title="Lessor Management"

            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader>
                  < Modal
                      visible={isModalAcceptedVisible}
                      onOk={handleAcceptOk}
                      cancelButtonProps={{ style: { display: 'none' } }}            
                    >
                      <Space direction="vertical">
                        {/* @ts-ignore */}
                        <p>{enteredstatus} {currentLessor.Name}</p>
                      </Space>
                    </Modal>

                  </IonCardHeader>

                  <IonCardContent>

                    <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>

                      <DataGrid
                        rows={data1}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            { columnField: 'Name', operatorValue: 'contains', value: '' },
                          ],
                        }}
                      />
                    </div>
                    <IonRow>
                      <IonCol>
                        <IonRow>
                          <IonCol size="">
                            <Modal width={1000} title="View Lessor Details" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                              <IonGrid>
                                <IonRow>
                                  <IonCol size="12" style={{ paddingLeft: "40px" }}>
                                    <IonCard>
                                      <IonCardHeader>
                                      </IonCardHeader>
                                      <IonCardContent>
                                        <IonRow>
                                            <IonCol>
                                             
                                              {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="ID" variant="outlined" value={PropertyObject.id}  />                                                                                   
                                            </IonCol>

                                            <IonCol>
                                                {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="Name" variant="outlined" value={PropertyObject.Name}  />
                                            </IonCol>
                                            <IonCol>                                               
                                            {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="Email" variant="outlined" value={PropertyObject.Email}  />
                                            </IonCol>

                                          </IonRow>
                                          
                                          <IonRow>
                                            <IonCol>
        
                                              {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="Profile Status" variant="outlined" value={PropertyObject.ProfileStatus}  />
                                            </IonCol>

                                            <IonCol>
                                            
                                                 {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="Verified Status" variant="outlined" value={PropertyObject.VerifiedStatus}  />
                                            
                                            </IonCol>

                                            <IonCol>
                                              
                                               {/* @ts-ignore */}
                                            <TextField id="outlined-basic" label="User Type" variant="outlined" value={PropertyObject.UserType}  />
                                            </IonCol>

                                          </IonRow>  
                                    

                                      </IonCardContent>
                                    </IonCard>
                                  </IonCol>
                                </IonRow>
                              </IonGrid>

                            </Modal>
                          </IonCol>
                        </IonRow>
                      </IonCol>
                    </IonRow>

                    {/* <Link to="/dashboard">
  <Button type="primary">View lessor details</Button>
  </Link> */}
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>

        </Space>
      </IonContent>
    </IonPage>

  );
}

export default Lessor;